export enum DrmType {
    WIDEVINE = "com.widevine.alpha",
    PLAYREADY = "com.microsoft.playready",
    CLEAR_KEY = "org.w3.clearkey",
    FAIRPLAY_1_0 = "com.apple.fps.1_0"
}

